// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wKu02oJhE0IR2d {
  grid-area: country;
}
.wKu02oJhE0IR2d input[type='text']:focus {
  box-shadow: none;
}
`, ""]);
// Exports
export var container = `wKu02oJhE0IR2d`;
export default ___CSS_LOADER_EXPORT___;
